import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import { Button, FormControl, Grid, TextField, OutlinedInput, InputLabel, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';

import API from '../../config/api';
import { setAccount } from '../../redux/actions/account';
import { errorField } from '../../utils/helpers';
// import configureStore from '../../redux'
// import { setAccount } from '../../redux/actions/account'

import Loader from '../../component/Loader';

// const store = configureStore()

const PhoneMaskedInput = (props) => {
	const { inputRef, ...other } = props;

	return (
		<MaskedInput
			{...other}
			ref={(ref) => inputRef(ref ? ref.inputElement : null)}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			keepCharPositions={true}
			showMask
		/>
	);
};

const ZipMaskedInput = (props) => {
	const { inputRef, ...other } = props;

	return <MaskedInput {...other} ref={(ref) => inputRef(ref ? ref.inputElement : null)} mask={[/[1-9]/, /\d/, /\d/, /\d/, /\d/]} placeholderChar={'\u2000'} guide={false} />;
};

const ReadOnlyInformation = (props) => {
	const formatPhoneNumber = (phone) => {
		const phoneNumber = phone || '';
		const number = phoneNumber.match(/(\d{3})(\d{3})(\d{4})/);
		return phoneNumber ? `(${number[1]}) ${number[2]}-${number[3]}` : null;
	};

	const hasSecondParent = props.account.secondParentFirstName || props.account.secondParentLastName;

	return (
		<Fragment>
			<div className='user-information'>
				<p className='user-information__section-header'>Parent/Guardian</p>
				<p>
					First Name: <span>{props.account.firstName}</span>
				</p>
				<p>
					Last Name: <span>{props.account.lastName}</span>
				</p>
				{hasSecondParent && (
					<>
						<p className='user-information__section-header'>Additional Parent/Guardian</p>
						<p>
							First Name: <span>{props.account.secondParentFirstName || '—'}</span>
						</p>
						<p>
							Last Name: <span>{props.account.secondParentLastName || '—'}</span>
						</p>
					</>
				)}
				<p className='user-information__section-header'>Information</p>
				<p>
					Address: <span>{props.account.address}</span>
				</p>
				<p>
					City: <span>{props.account.city}</span>
				</p>
				<p>
					State: <span>{props.account.state}</span>
				</p>
				<p>
					ZIP: <span>{props.account.postalCode}</span>
				</p>
				<p>
					Phone: <span>{formatPhoneNumber(props.account.phone)}</span>
				</p>
				<p>
					Email Address: <span>{props.account.email}</span>
				</p>
			</div>
			<Button color='primary' startIcon={<EditIcon />} className='edit-user__button' onClick={props.handleEdit}>
				Edit user information
			</Button>
		</Fragment>
	);
};

const EditableInformation = (props) => {
	const [loading, setLoading] = useState(false);
	const [formError, setFormError] = useState(null);
	const [formState, setFormState] = useState({
		firstName: props.account.firstName || '',
		lastName: props.account.lastName || '',
		secondParentFirstName: props.account.secondParentFirstName || '',
		secondParentLastName: props.account.secondParentLastName || '',
		address: props.account.address || '',
		city: props.account.city || '',
		state: props.account.state || '',
		postalCode: props.account.postalCode || '',
		phone: props.account.phone || '',
		email: props.account.email || '',
	});

	const handleChange = (event) => {
		const { name, value } = event.target;
		setFormState({ ...formState, [name]: value });
		setFormError(null);
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		setLoading(true);
		setFormError(null);

		const phone = formState.phone.replace(/[^\d]/g, '');
		const data = { ...formState, phone };

		try {
			const res = await API.UpdateAccount(props.token, data);
			if (res.status !== 201) {
				setFormError({ field: res.field, message: res.message });
				return;
			}
			props.setAccount({ ...props.account, ...data });
			props.handleEdit();
		} catch (err) {
			setFormError({ message: err.message || 'An error occurred. Please try again.' });
		} finally {
			setLoading(false);
		}
	};

	const errors = errorField(formError);

	return (
		<div className='user-information__form'>
			<form onSubmit={handleSubmit}>
				<FormControl component='fieldset' fullWidth>
					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<TextField label='Parent First Name' name='firstName' value={formState.firstName} variant='outlined' inputProps={{ maxLength: 120 }} onChange={handleChange} required fullWidth />
						</Grid>
						<Grid item xs={12} md={6}>
							<TextField label='Parent Last Name' name='lastName' value={formState.lastName} variant='outlined' inputProps={{ maxLength: 120 }} onChange={handleChange} required fullWidth />
						</Grid>
						<Grid item xs={12}>
							<Typography variant='body2' color='textSecondary' style={{ marginTop: 8 }}>
								Add additional Parent/Guardian (optional).
							</Typography>
						</Grid>
						<Grid item xs={12} md={6}>
							<TextField
								label='Additional Parent First Name'
								name='secondParentFirstName'
								value={formState.secondParentFirstName}
								variant='outlined'
								inputProps={{ maxLength: 120 }}
								onChange={handleChange}
								fullWidth
							/>
						</Grid>
						<Grid item xs={12} md={6}>
							<TextField
								label='Additional Parent Last Name'
								name='secondParentLastName'
								value={formState.secondParentLastName}
								variant='outlined'
								inputProps={{ maxLength: 120 }}
								onChange={handleChange}
								fullWidth
							/>
						</Grid>
						<Grid item xs={12}>
						<br/>
						<label>Physical Street Address (No P.O. Box)</label>
						</Grid>						
						<Grid item xs={12}>
							<TextField label='Address' name='address' value={formState.address} variant='outlined' inputProps={{ maxLength: 320 }} onChange={handleChange} required fullWidth />
						</Grid>
						<Grid item xs={12} md={4}>
							<TextField label='City' name='city' value={formState.city} variant='outlined' inputProps={{ maxLength: 45 }} onChange={handleChange} required fullWidth />
						</Grid>
						<Grid item xs={12} md={4}>
							<TextField label='State' name='state' value={formState.state} variant='outlined' inputProps={{ maxLength: 45 }} onChange={handleChange} required fullWidth />
						</Grid>
						<Grid item xs={12} md={4}>
							<FormControl className='masked-input' error={errors.postalCode} required>
								<InputLabel htmlFor='zip'>ZIP</InputLabel>
								<OutlinedInput name='postalCode' label='ZIP *' value={formState.postalCode} inputComponent={ZipMaskedInput} inputProps={{ maxLength: 11 }} onChange={handleChange} />
							</FormControl>
						</Grid>
						<Grid item xs={12} md={6}>
							<FormControl className='masked-input' error={errors.phone} fullWidth required>
								<InputLabel htmlFor='phone'>Phone</InputLabel>
								<OutlinedInput name='phone' label='Phone *' value={formState.phone} inputComponent={PhoneMaskedInput} inputProps={{ maxLength: 30 }} onChange={handleChange} />
							</FormControl>
						</Grid>
						<Grid item xs={12} md={6}>
							<TextField
								label='Primary Email Address'
								name='email'
								error={errors.email}
								type='email'
								value={formState.email}
								variant='outlined'
								inputProps={{ maxLength: 254 }}
								onChange={handleChange}
								required
								fullWidth
							/>
						</Grid>
					</Grid>
				</FormControl>

				<span className='warning'>Note: Primary Email and Phone Number is used as recovery information, it is only possible to have this in one account.</span>

				{formError && (
					<Alert severity='error' onClose={() => setFormError(null)} style={{ marginTop: 20 }}>
						{formError.message}
					</Alert>
				)}

				<div className='form-action-buttons'>
					{!loading ? (
						<Button color='primary' type='submit' startIcon={<SaveIcon />} disableRipple>
							Save
						</Button>
					) : (
						<Loader loading={true} />
					)}
					<Button color='secondary' endIcon={<CloseIcon />} onClick={props.handleEdit} disableRipple>
						Close
					</Button>
				</div>
			</form>
		</div>
	);
};

const UserInformation = (props) => {
	const [isEdit, setIsEdit] = useState(false);

	const handleEdit = () => setIsEdit(!isEdit);

	return (
		<div className='profile-page__user-information--tab'>
			<h3 className='section-title'>Profile: Registered Parent User Information</h3>
			<Grid container>
				<Grid item xs={12} lg={7}>
					{!isEdit ? (
						<ReadOnlyInformation account={props.account} handleEdit={handleEdit} />
					) : (
						<EditableInformation account={props.account} token={props.token} handleEdit={handleEdit} setAccount={props.setAccount} />
					)}
				</Grid>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		account: state.account,
	};
};

const mapDispatchToProps = {
	setAccount,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserInformation);
